import React from 'react';

import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Form } from '@/components/ui/form';
import { Alert } from '../../../../shared/components/Alert';
import { InputField, SubmitButton } from '../../../../shared/components/Form';
import Header from '../components/Header';
import { ERROR_TITLES, SUCCESS_MESSAGES } from '../constants';
import { useRequestUnlockForm } from '../hooks';

const alertIcon = <FontAwesomeIcon icon={faCircleExclamation} />;

const RequestUnlock = () => {
  const {
    error,
    form,
    handleSubmit: onSubmit,
    isSubmitting,
    submissionSuccessful,
  } = useRequestUnlockForm();

  return (
    <div className="flex items-center justify-center bg-muted min-h-svh">
      <div className="flex flex-col gap-6 w-full max-w-xs">
        <Header title="Request Unlock" />

        <Form {...form}>
          <form className="flex flex-col gap-6" onSubmit={form.handleSubmit(onSubmit)}>
            <InputField control={form.control} label="Email" name="email" type="email" />
            <SubmitButton isLoading={isSubmitting}>Send Unlock Link</SubmitButton>

            {submissionSuccessful && !form.formState.isDirty && (
              <Alert
                description={SUCCESS_MESSAGES.unlock.request.description}
                icon={alertIcon}
                title={SUCCESS_MESSAGES.unlock.request.title}
                variant="success"
              />
            )}

            {error && (
              <Alert
                description={error.message}
                icon={alertIcon}
                title={ERROR_TITLES.unlock.request}
                variant="destructive"
              />
            )}
          </form>
        </Form>
      </div>
    </div>
  );
};

export default RequestUnlock;
